import {
  createContext,
  Dispatch,
  PropsWithChildren,
  SetStateAction,
  useContext,
  useState,
} from "react";
import { usePermission } from "src/hooks";
import Dialog from "./components/Dialog";
import Toggle from "./components/Toggle";
import MenuItem from "./components/MenuItem";

type DialogProviderContext = {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
};

const DialogProviderContext = createContext<DialogProviderContext | undefined>(
  undefined
);

const useDialogProviderContext = () => {
  const context = useContext(DialogProviderContext);
  if (!context) {
    throw new Error(
      "DialogProvider components must be rendered within DialogProviderContext"
    );
  }
  return context;
};

//Wrapper of Dialog Provider Component
type DialogProviderProps = {
  permissionKey?: string;
} & PropsWithChildren;

const DialogProvider = ({ children, permissionKey }: DialogProviderProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const { hasPermission } = usePermission();

  if (permissionKey && !hasPermission(permissionKey)) {
    return <></>;
  }

  return (
    <DialogProviderContext.Provider value={{ isOpen, setIsOpen }}>
      {children}
    </DialogProviderContext.Provider>
  );
};

DialogProvider.DialogInOne = Dialog;
DialogProvider.Toggle = Toggle;
DialogProvider.MenuItem = MenuItem;

export default DialogProvider;
export { useDialogProviderContext };
